import React from 'react';
import { Fragment } from 'react';
import { BlockControls, InspectorControls } from '@wordpress/editor';
import { toKebabCase, toPascalCase } from './utils';
import { ClassicBlockWrapper } from './BlockEditor';
import defineBlock from './defineBlock';

/**
 * Register a Block type as a Gutenberg component.
 * This force registration of any block as a Smartfire block available in the page.
 * This function is handled by the compilation magic, but you can use yourself to directly register blocks.
 *
 * @param {string} name the component identifier
 * @param {Promise<React.Component>} component
 */
export default function registerBlock(name, component) {
  if (typeof name !== 'string') {
    component = Promise.resolve(name);
    name = name.name;
  }
  window.smartfire = Object.assign(window.smartfire || {}, {});
  const extender = {};
  extender[name] = () => {
    return Promise.resolve(component()).then(async blockModule => {
      let block = blockModule.default || blockModule;
      const blockApi = await import('@wordpress/blocks');
      const componentName = 'smartfire/' + toKebabCase(name);
      if (
        typeof blockApi.registerBlockType === 'function' &&
        blockApi.getBlockTypes().filter(t => t.name === componentName).length <=
          0
      ) {
        if (block.classSupport) {
          // Support for old generation class blocks
          block = defineBlock({
            Block: ClassicBlockWrapper(block),
            smartProps: block.smartProps,
            setup: ClassicBlockWrapper.extractSetup(block),
          });
        }
        if (block._smartfire) {
          const setup = block._smartfire.configureGutenberg(name);
          blockApi.registerBlockType(componentName, setup);
        }
      }

      return block;
    });
  };
  extender[toPascalCase(name)] = extender[name];
  extender[toKebabCase(name)] = extender[name];
  window.smartfire.components = Object.assign(
    window.smartfire.components || {},
    extender
  );
}
